(() => {
  angular.module('pims').directive('loadingWhen', () => {
    return {
      restrict: 'A',
      scope: {
        loadingWhen: '='
      },

      link(scope, element, attrs) {
        const type = attrs.loadingType || 'white';
        scope.$watch('loadingWhen', current => {
          element[current ? 'addClass' : 'removeClass'](`btn-loading btn-loading-${type}`);
        });
      }

    };
  });
})();